import React, { useCallback, useEffect, useState } from 'react';
import moment from 'moment';
import _ from 'lodash';

import CustomSelect from '../CustomSelect';
import MultiRoleDatePicker, { PICKERTYPE_DATERANGE } from '../MultiRoleDatePicker';
import CustomButton from '../CustomButton';
import ContextMenuComponent from '../ContextMenuComponent';
import { DATE_FORMAT_DOT_MDY, DATE_FORMAT_YMD } from '../../../constants/dateFormatsConst';

const toTitleCase = str => {
  if (typeof str === 'string') {
    return str.replace(/(?:^|\s)\w/g, match => match.toUpperCase());
  }
  return str;
};

//#region JSX Component Filter Popup Code

export const Popup_NumberFilter = ({
  column,
  columnFilters,
  setColumnFilters,
  toggleFilterPopup,
  popoverId,
  closeFilterPopup,
  columnTypeFilters,
  setColumnTypeFilters
}) => {
  const numberFilterList = [
    { label: 'Equals', value: 'equals' },
    { label: 'Less Than', value: 'lessThan' },
    { label: 'Greater Than', value: 'greaterThan' },
    { label: 'In Range', value: 'inRange' }
  ];
  const [filterValue, setFilterValue] = useState('');
  const [maxFilterValue, setMaxFilterValue] = useState('');
  const [filterType, setFilterType] = useState(numberFilterList[0]);
  const [filterSummary, setFilterSummary] = useState([]);

  const Reset = () => {
    setFilterType(numberFilterList[0]); // Reset the filterType to 'contains'
    setFilterValue(''); // Reset the filterValue to an empty string
    setFilterSummary('');
    closeFilterPopup();
    setMaxFilterValue('');
  };

  const UpdateColumnTypeFilters = (colTypeFilters, filterValueObj) => {
    let numObj = {};
    if (!colTypeFilters?.number) {
      numObj.number = {
        [column.id]: filterValueObj
      };
    } else {
      colTypeFilters.number[column.id] = filterValueObj;
      numObj = colTypeFilters;
    }
    setColumnTypeFilters({ ...colTypeFilters, ...numObj });
  };

  const clearFilter = columnId => {
    const newColumnFilters = { ...columnFilters };
    delete newColumnFilters[columnId];
    setColumnFilters(newColumnFilters);
    Reset();
  };

  const applyNumberFilter = () => {
    let filterValueStr = filterValue.trim();
    if (filterType.value === 'inRange') {
      filterValueStr = `${filterType.value}-${filterValue},${maxFilterValue}`;
    } else {
      filterValueStr = `${filterType.value}-${filterValueStr}`;
    }
    setColumnFilters(prevFilters => ({
      ...prevFilters,
      [column.id]: filterValueStr
    }));
    UpdateColumnTypeFilters(columnTypeFilters, filterValueStr);
    setFilterSummary([{ columnId: column.id, value: filterValueStr }]);
    closeFilterPopup();
  };

  const clearNumberFilter = () => {
    setColumnFilters(prevFilters => ({
      ...prevFilters,
      [column.id]: ''
    }));
    setColumnTypeFilters(prevFilters => ({
      ...prevFilters,
      number: {}
    }));
    Reset();
  };

  useEffect(() => {
    if (columnTypeFilters && Object.keys(columnTypeFilters).length > 0) {
      const numberObj = columnTypeFilters?.number ?? {};

      const prevFilter = Object.keys(numberObj).map(key => {
        const filterValueObj = numberObj[key];
        const obj = {
          columnId: key,
          value: filterValueObj
        };
        return obj;
      });
      setFilterSummary(prevFilter);
    }
  }, []);

  const menuOption = {
    buttonDropdown: { id: `menuOption${popoverId}` },
    dropdownToggle: {
      color: 'default',
      className: 'shadow-none p-0',
      children: (
        <div className="d-flex align-items-center">
          <span
            id={popoverId}
            className="pr-2 cursor-pointer"
            onClick={() => {
              toggleFilterPopup(column.id);
            }}
          >
            <i className="fa fa-fw fa-filter text-primary" />
          </span>
          <input
            id={`textFilterId_${column.id}`}
            type="text"
            className="form-control"
            style={{ background: 'none' }}
            value={filterValue}
            onFocus={e => (e.target.readOnly = false)}
            onBlur={e => (e.target.readOnly = false)}
            onChange={e => setFilterValue(e.currentTarget.value)}
            autoComplete="off"
            aria-autocomplete="none"
            placeholder={
              column.Header && column.Header.trim() ? `Enter ${column.Header.trim()}` : 'Enter text'
            }
            onKeyDown={e => {
              if (e.key === 'Enter') {
                e.preventDefault();
                applyNumberFilter(true);
              }
            }}
            onClick={e => {
              e.stopPropagation();
            }}
          />
        </div>
      ),
      toggleIcon: false
    },
    dropdownMenu: {
      className: 'p-2 r-5 b-secondary',
      options: [
        {
          className: 'p-2',
          notDropdownClass: true,
          children: (
            <div onClick={e => e.stopPropagation()} className="filter-popup">
              <CustomSelect
                options={numberFilterList}
                selected={filterType}
                onChange={e => setFilterType(e)}
                className="select-filter"
              />

              {filterType.value === 'inRange' ? (
                <div>
                  <input
                    className="form-control"
                    type="number"
                    value={filterValue}
                    onChange={e => setFilterValue(e.target.value)}
                    placeholder="Min"
                  />
                  <span>-</span>
                  <input
                    className="form-control"
                    type="number"
                    value={maxFilterValue}
                    onChange={e => setMaxFilterValue(e.target.value)}
                    placeholder="Max"
                  />
                </div>
              ) : (
                <input
                  className="form-control"
                  type="number"
                  value={filterValue}
                  onChange={e => setFilterValue(e.target.value)}
                  placeholder={
                    column.Header && column.Header.trim() ? `Enter ${column.Header.trim()}` : 'Enter value'
                  }
                  onKeyDown={e => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      applyNumberFilter();
                    }
                  }}
                />
              )}

              <div className="pt-1 pb-1">
                <CustomButton outline color="primary" onClick={applyNumberFilter}>
                  Apply
                </CustomButton>
                <CustomButton outline color="secondary" className="ml-2" onClick={clearNumberFilter}>
                  Clear
                </CustomButton>
              </div>
            </div>
          )
        }
      ]
    }
  };

  return (
    <>
      <div>
        {filterSummary && filterSummary.length > 0 ? (
          <div
            id={popoverId}
            onClick={e => {
              e.stopPropagation();
              toggleFilterPopup(column.id);
            }}
          >
            <div className="">
              {filterSummary.map(tag => {
                if (tag?.columnId === column.id) {
                  return (
                    <div className="d-flex" key={tag.value}>
                      <input
                        type="text"
                        title={tag.value}
                        className="form-control text-dark-100"
                        value={tag.value}
                        readOnly
                      />
                      <i
                        className="fa fa-fw fa-close mr-2 text-danger mt-2 ml-2 pt-1"
                        title="Clear"
                        onClick={e => {
                          e.stopPropagation();
                          clearFilter(tag.columnId);
                        }}
                      />
                    </div>
                  );
                }
                return null;
              })}
            </div>
          </div>
        ) : (
          <ContextMenuComponent menuOption={menuOption} />
        )}
      </div>
    </>
  );
};

export const Popup_TextFilter = ({
  column,
  columnFilters,
  setColumnFilters,
  toggleFilterPopup,
  popoverId,
  closeFilterPopup,
  columnTypeFilters,
  setColumnTypeFilters
}) => {
  const stringFilterList = [
    { label: 'Contains', value: 'contains' },
    { label: 'Not contains', value: 'notContains' },
    { label: 'Equals', value: 'equals' },
    { label: 'Not equal', value: 'notEquals' },
    { label: 'Starts with', value: 'startsWith' },
    { label: 'Ends with', value: 'endsWith' },
    { label: 'Blank', value: 'blank' },
    { label: 'Not blank', value: 'notBlank' }
  ];
  const [filterValue, setFilterValue] = useState('');
  const [filterType, setFilterType] = useState(stringFilterList[0]);
  const [filterSummary, setFilterSummary] = useState([]);

  const Reset = () => {
    setFilterType(stringFilterList[0]); // Reset the filterType to 'contains'
    setFilterValue(''); // Reset the filterValue to an empty string
    closeFilterPopup();
    setFilterSummary('');
  };

  const UpdateColumnTypeFilters = (colTypeFilters, filterValueObj) => {
    let textObj = {};
    if (!colTypeFilters?.text) {
      textObj.text = {
        [column.id]: filterValueObj
      };
    } else {
      colTypeFilters.text[column.id] = filterValueObj;
      textObj = colTypeFilters;
    }
    setColumnTypeFilters({ ...colTypeFilters, ...textObj });
  };

  const applyTextFilter = useCallback(
    (outsideText = false) => {
      let filterValueObj = { filterType: outsideText ? 'contains' : filterType.value, value: filterValue };
      if (filterValueObj.filterType === 'blank' || filterValueObj.filterType === 'notBlank') {
        filterValueObj = { filterType: filterType.value, value: 'true' };
      }
      setColumnFilters(prevFilters => ({
        ...prevFilters,
        [column.id]: filterValueObj
      }));

      UpdateColumnTypeFilters(columnTypeFilters, filterValueObj);
      setFilterSummary(() => {
        const newFilterSummaryItem = {
          columnId: column.id,
          value: `${filterValueObj.filterType} ${
            filterValueObj.filterType === 'blank' || filterValueObj.filterType === 'notBlank'
              ? ''
              : `: ${filterValueObj.value}`
          }`
        };

        return [newFilterSummaryItem];
      });
    },
    [filterType.value, filterValue]
  );

  const clearTextFilter = () => {
    setColumnFilters(prevFilters => ({
      ...prevFilters,
      [column.id]: null
    }));
    setColumnTypeFilters(prevFilters => ({
      ...prevFilters,
      text: {}
    }));
    Reset();
  };

  const clearFilter = columnId => {
    const newColumnFilters = { ...columnFilters };
    delete newColumnFilters[columnId];
    setColumnFilters(newColumnFilters);

    let filterValueObj = { filterType: filterType.value, value: filterValue };
    if (filterValueObj.filterType === 'blank' || filterValueObj.filterType === 'notBlank') {
      filterValueObj = { filterType: filterType.value, value: 'true' };
    }
    UpdateColumnTypeFilters(newColumnFilters, filterValueObj);
    Reset();
  };

  useEffect(() => {
    if (columnTypeFilters && Object.keys(columnTypeFilters).length > 0) {
      const textObj = columnTypeFilters?.text ?? {};

      const prevFilter = Object.keys(textObj).map(key => {
        const filterValueObj = textObj[key];
        const obj = {
          columnId: key,
          value: `${filterValueObj.filterType} ${
            filterValueObj.filterType === 'blank' || filterValueObj.filterType === 'notBlank'
              ? ''
              : `: ${filterValueObj.value}`
          }`
        };
        return obj;
      });
      setFilterSummary(prevFilter);
    }
  }, []);

  const menuOption = {
    buttonDropdown: { id: `menuOption${popoverId}` },
    dropdownToggle: {
      color: 'default',
      className: 'shadow-none p-0',
      tag: 'div',
      children: (
        <div className="d-flex align-items-center">
          <span
            id={popoverId}
            className="pr-2 cursor-pointer"
            onClick={() => {
              toggleFilterPopup(column.id);
            }}
          >
            <i className="fa fa-fw fa-filter text-primary" />
          </span>
          <input
            id={`textFilterId_${column.id}`}
            type="text"
            className="form-control"
            style={{ background: 'none' }}
            value={filterValue}
            onFocus={e => (e.target.readOnly = false)}
            onBlur={e => (e.target.readOnly = false)}
            onChange={e => setFilterValue(e.currentTarget.value)}
            autoComplete="off"
            aria-autocomplete="none"
            placeholder={
              column.Header && column.Header.trim() ? `Enter ${column.Header.trim()}` : 'Enter text'
            }
            onKeyDown={e => {
              if (e.key === 'Enter') {
                e.preventDefault();
                applyTextFilter(true);
              }
            }}
            onClick={e => {
              e.stopPropagation();
            }}
          />
        </div>
      ),
      toggleIcon: false
    },
    dropdownMenu: {
      className: 'p-2 r-5 b-secondary',
      options: [
        {
          className: 'p-2',
          notDropdownClass: true,
          children: (
            <div onClick={e => e.stopPropagation()} className="filter-popup">
              <CustomSelect
                options={stringFilterList}
                selected={filterType}
                onChange={e => {
                  setFilterType(e);
                }}
                className="select-filter"
              />

              {filterType.value === 'blank' || filterType.value === 'notBlank' ? null : (
                <input
                  type="text"
                  className="form-control"
                  value={filterValue}
                  onChange={e => setFilterValue(e.target.value)}
                  placeholder={
                    column.Header && column.Header.trim() ? `Enter ${column.Header.trim()}` : 'Enter text'
                  }
                  autoComplete="nope"
                  onKeyDown={e => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      applyTextFilter();
                    }
                  }}
                />
              )}
              <div className="pt-1 pb-1">
                <CustomButton
                  outline
                  color="primary"
                  onClick={() =>
                    (filterValue.trim() || filterType.value === 'blank' || filterType.value === 'notBlank') &&
                    applyTextFilter()
                  }
                >
                  Apply
                </CustomButton>
                <CustomButton outline color="secondary" className="ml-2" onClick={() => clearTextFilter()}>
                  Clear
                </CustomButton>
              </div>
            </div>
          )
        }
      ]
    }
  };

  return (
    <>
      <div>
        {filterSummary && filterSummary.length > 0 ? (
          <div
            id={popoverId}
            onClick={e => {
              e.stopPropagation();
              toggleFilterPopup(column.id);
            }}
          >
            <div className="">
              {filterSummary.map(tag => {
                if (tag?.columnId === column.id) {
                  return (
                    <div className="d-flex" key={tag.value}>
                      <input
                        type="text"
                        title={tag.value}
                        className="form-control text-dark-100"
                        value={tag.value}
                        readOnly
                      />
                      <i
                        className="fa fa-fw fa-close mr-2 text-danger mt-2 ml-2 pt-1"
                        title="Clear"
                        onClick={e => {
                          e.stopPropagation();
                          clearFilter(tag.columnId);
                        }}
                      />
                    </div>
                  );
                }
                return null;
              })}
            </div>
          </div>
        ) : (
          <ContextMenuComponent menuOption={menuOption} />
        )}
      </div>
    </>
  );
};

export const Popup_DropdownFilter = ({
  column,
  columnDef,
  data,
  columnFilters,
  setColumnFilters,
  toggleFilterPopup,
  popoverId,
  closeFilterPopup
}) => {
  const [filterValue, setFilterValue] = useState('All');
  const [filterSummary, setFilterSummary] = useState([]);
  const [filterOptions, setFilterOptions] = useState([]);

  useEffect(() => {
    const dropdownOptions = () => {
      if (column) {
        const id = column?.id;
        const options = data?.reduce((acc, row) => {
          const rowValue = row[id];
          if (!acc.some(option => option.value === rowValue)) {
            acc.push({ label: toTitleCase(rowValue), value: rowValue });
          }
          return acc;
        }, []);
        setFilterOptions(options);
      }
    };
    if (filterOptions.length === 0) {
      dropdownOptions();
    }
  }, [data, column, setFilterOptions]);

  const clearFilter = columnId => {
    const newColumnFilters = { ...columnFilters };
    delete newColumnFilters[columnId];
    setColumnFilters(newColumnFilters);
    setFilterValue('All');
    setFilterSummary([]);
  };

  useEffect(() => {
    if (columnDef?.filterSelectedByDefaultOption) {
      const colId = columnDef?.filterSelectedByDefaultOption[0]?.fieldName;
      let value = columnDef?.filterSelectedByDefaultOption;
      if (!value && filterValue === 'All') {
        value = null;
      }
      // else {
      //   value = filterValue ? filterValue : value;
      // }
      if (value === null) {
        clearFilter(colId);
      } else {
        setColumnFilters(prevFilters => ({
          ...prevFilters,
          [colId]: value
        }));
        setFilterSummary([{ columnId: colId, value: value }]);
        setFilterValue(value);
      }
    }
  }, []);

  const applyDropdownFilter = getVal => {
    const value = getVal?.length > 0 ? getVal : [];
    if (value.length < 1) {
      clearFilter(column.id);
    } else {
      setColumnFilters(prevFilters => ({
        ...prevFilters,
        [column.id]: value
      }));
      setFilterSummary([{ columnId: column.id, value: value }]);
      setFilterValue(value);
    }
  };

  const clearDropdownFilter = () => {
    const newColumnFilters = { ...columnFilters };
    delete newColumnFilters[column.id];
    setFilterValue([]);
    setColumnFilters(newColumnFilters);
    setFilterSummary('');
    closeFilterPopup();
  };

  const menuOption = {
    buttonDropdown: { id: `menuOption${popoverId}` },
    dropdownToggle: {
      color: 'default',
      className: 'shadow-none p-0',
      tag: 'div',
      children: (
        <div
          id={popoverId}
          style={{ marginTop: '0.6rem' }}
          className="float-left border-bottom-0 cursor-pointer"
          onClick={() => {
            toggleFilterPopup(column.id);
          }}
        >
          <i className="fa fa-fw fa-filter text-primary" />
        </div>
      ),
      toggleIcon: false
    },
    dropdownMenu: {
      className: 'p-2 r-5 b-secondary',
      options: [
        {
          className: 'p-2',
          notDropdownClass: true,
          children: (
            <div onClick={e => e.stopPropagation()} className="filter-popup">
              <CustomSelect
                options={filterOptions}
                selected={filterValue}
                onChange={applyDropdownFilter}
                isClearable={filterValue.length > 1}
                isMulti
                className="select-filter"
              />
              <div className="pt-1 pb-1">
                <CustomButton outline color="secondary" onClick={clearDropdownFilter}>
                  Clear
                </CustomButton>
              </div>
            </div>
          )
        }
      ]
    }
  };

  return (
    <>
      <div>
        {filterSummary.length > 0 ? (
          <div
            id={popoverId}
            onClick={e => {
              e.stopPropagation();
              toggleFilterPopup(column.id);
            }}
          >
            <div className="">
              {filterSummary.map(tag => (
                <div className="d-flex" key={tag?.columnId}>
                  <input
                    type="text"
                    readOnly
                    title={tag.value.map(v => v.value).join(', ')}
                    className="form-control text-dark-100"
                    value={tag.value.map(v => v.value).join(', ')}
                  />
                  <i
                    className="fa fa-fw fa-close mr-2 text-danger mt-2 ml-2 pt-1"
                    title="Clear"
                    onClick={e => {
                      e.stopPropagation();
                      clearFilter(tag.columnId);
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        ) : (
          <ContextMenuComponent menuOption={menuOption} />
        )}
      </div>
    </>
  );
};

export const Popup_DateRangeFilter = ({
  column,
  columnFilters,
  setColumnFilters,
  toggleFilterPopup,
  popoverId,
  closeFilterPopup
}) => {
  const [startDate, setStartDate] = useState(moment().add(-7, 'days').toDate());
  const [endDate, setEndDate] = useState(moment().toDate());
  const [filterSummary, setFilterSummary] = useState([]);

  const clearFilter = columnId => {
    setStartDate(moment().add(-7, 'days').toDate());
    setEndDate(moment().toDate());
    const newColumnFilters = { ...columnFilters };
    delete newColumnFilters[columnId];
    setColumnFilters(newColumnFilters);
    setFilterSummary([]);
    closeFilterPopup();
  };

  const applyDateRangeFilter = dates => {
    const [start, end] = dates;
    const filterValue = start && end ? `${start.toString()},${end.toString()}` : undefined;
    const startFormatted = moment(start).format(DATE_FORMAT_DOT_MDY);
    const endFormatted = moment(end).format(DATE_FORMAT_DOT_MDY);
    setStartDate(start);
    setEndDate(end);
    if (end) {
      setFilterSummary([{ columnId: column.id, value: `${startFormatted}-${endFormatted}` }]);
      setColumnFilters(prevFilters => ({
        ...prevFilters,
        [column.id]: filterValue
      }));
      closeFilterPopup();
    }
  };

  const clearDateRangeFilter = () => {
    setColumnFilters(column.id, undefined); // Clear the filter
    clearFilter(column.id);
  };

  const menuOption = {
    buttonDropdown: { id: `menuOption${popoverId}` },
    dropdownToggle: {
      color: 'default',
      className: 'shadow-none p-0',
      children: (
        <span
          id={popoverId}
          className="float-left border-bottom-0 cursor-pointer"
          style={{ marginTop: '0.6rem' }}
          onClick={() => {
            toggleFilterPopup(column.id);
          }}
        >
          <i className="fa fa-fw fa-filter text-primary" />
        </span>
      ),
      toggleIcon: false
    },
    dropdownMenu: {
      className: 'p-2 r-5 b-secondary',
      options: [
        {
          className: 'p-2',
          notDropdownClass: true,
          children: (
            <div onClick={e => e.stopPropagation()} className="filter-popup">
              <MultiRoleDatePicker
                startDate={startDate}
                endDate={endDate}
                onChange={e => {
                  applyDateRangeFilter(e);
                }}
                buttonStyle={{ width: '10.5rem' }}
                pickerType={PICKERTYPE_DATERANGE}
              />
              <div className="pt-1 pb-1">
                <CustomButton color="secondary" outline onClick={clearDateRangeFilter}>
                  Clear
                </CustomButton>
              </div>
            </div>
          )
        }
      ]
    }
  };

  return (
    <>
      {filterSummary.length > 0 ? (
        <div
          id={popoverId}
          onClick={e => {
            e.stopPropagation();
            toggleFilterPopup(column.id);
          }}
        >
          <div className="">
            {filterSummary.map(tag => (
              <div className="d-flex" key={tag.value}>
                <input
                  type="text"
                  title={tag.value}
                  className="form-control text-dark-100"
                  value={tag.value}
                  readOnly
                />
                <i
                  className="fa fa-fw fa-close mr-2 text-danger mt-2 ml-2 pt-1"
                  title="Clear"
                  onClick={e => {
                    e.stopPropagation();
                    clearFilter(tag.columnId);
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      ) : (
        <ContextMenuComponent menuOption={menuOption} />
      )}
    </>
  );
};

//#endregion

//#region According Filter data Functions

export const textFilterDataFn = (rows, columnId, filterValue) => {
  return rows.filter(row => {
    const rowValue = row[columnId];
    if (!filterValue || !filterValue?.value) {
      return true;
    } // If filterValue is not set, return all rows

    const { filterType, value } = filterValue;
    const rowValueLower = rowValue?.toString()?.toLowerCase() ?? '';
    const filterValueLower = value?.toLowerCase();

    switch (filterType) {
      case 'contains':
        return rowValueLower?.includes(filterValueLower);
      case 'notContains':
        return !rowValueLower?.includes(filterValueLower);
      case 'equals':
        return rowValueLower === filterValueLower;
      case 'startsWith':
        return rowValueLower?.startsWith(filterValueLower);
      case 'endsWith':
        return rowValueLower?.endsWith(filterValueLower);
      case 'notEquals':
        return rowValueLower !== filterValueLower;
      case 'blank':
        return filterValueLower === 'true' ? rowValueLower === '' : true;
      case 'notBlank':
        return filterValueLower === 'true' ? rowValueLower !== '' : true;
      default:
        return true;
    }
  });
};
export const numberFilterDataFn = (rows, columnId, filterValue) => {
  return rows.filter(row => {
    const rowValue = parseFloat(row[columnId]);
    if (!filterValue) {
      return true;
    }

    const splitArr = filterValue.split('-');
    const [filterType, value] = splitArr;

    switch (filterType) {
      case 'equals':
        return rowValue === parseFloat(value);
      case 'lessThan':
        return rowValue < parseFloat(value);
      case 'greaterThan':
        return rowValue > parseFloat(value);
      case 'inRange':
        return (function () {
          const [min, max] = value.split(',').map(parseFloat);
          return rowValue >= min && rowValue <= max;
        })();
      default:
        return true;
    }
  });
};
export const dropdownFilterDataFn = (rows, columnId, filterValue) => {
  const fvalue = filterValue?.length > 0 ? filterValue?.map(v => v.value) : [];
  return rows.filter(row => {
    const rowValue = row[columnId];
    return fvalue.includes(rowValue);
  });
};
export const dateFilterDataFn = (rows, columnId, filterValue, column) => {
  return rows.filter(row => {
    const rowValue = row[columnId];

    if (!filterValue) {
      return true;
    }
    const [startDate, endDate] = filterValue.split(',');
    const dateFormat = column?.dateFormat || DATE_FORMAT_YMD;
    const formattedRowValue = moment(rowValue).format(dateFormat);

    const formattedStartDate = moment(new Date(startDate)).format(dateFormat);
    const formattedEndDate = moment(new Date(endDate)).format(dateFormat);

    const status = moment(formattedRowValue).isBetween(formattedStartDate, formattedEndDate, null, '[]');
    return status;
  });
};

//#endregion

//#region All Column Sorting Functionality

export const customSortFunction = (rowA, rowB, columnId /*sortOrder*/) => {
  // const sortOrderBoolVal = sortOrder.find(x => x.id === columnId)?.desc || false;

  let valueA = rowA.original[columnId];
  let valueB = rowB.original[columnId];

  if (typeof valueA === 'string') {
    valueA = valueA ? valueA?.trim()?.toLowerCase() : '';
  }
  if (typeof valueB === 'string') {
    valueB = valueB ? valueB?.trim()?.toLowerCase() : '';
  }

  if (valueA === '' || valueA === null || valueA === undefined) {
    return 1;
  }
  if (valueB === '' || valueB === null || valueB === undefined) {
    return -1;
  }

  // Use lodash orderBy for sorting
  const result = _.orderBy([valueA, valueB], []);
  return result[0] === valueA ? -1 : 1;
};

//#endregion

export const Popup_CustomHtml = ({
  toggleFilterPopup,
  popoverId,
  closeFilterPopup,
  iconHtml = '',
  onApplyClick,
  buttonText = '',
  showApplyButton = true,
  popUpContent
}) => {
  const [filterValue, setFilterValue] = useState('');
  const applyTextFilter = e => {
    // Send filterValue to parent component
    // Example: onApplyFilter(filterValue);
    if (popUpContent) {
      onApplyClick?.(e);
    } else {
      const applycall = onApplyClick?.({ value: filterValue, event: e });

      if (applycall) {
        closeFilterPopup();
        setFilterValue('');
      }
    }
  };

  const clearTextFilter = e => {
    e.stopPropagation();
    setFilterValue('');
    closeFilterPopup();
  };

  return (
    <div>
      <ContextMenuComponent
        menuOption={{
          buttonDropdown: { id: `popup-${popoverId}` },
          dropdownToggle: {
            color: 'default',
            className: 'shadow-none p-0',

            children: iconHtml ? (
              iconHtml
            ) : (
              <div className="d-flex align-items-center">
                <span
                  id={popoverId}
                  className="pr-2 cursor-pointer"
                  onClick={() => {
                    toggleFilterPopup();
                  }}
                >
                  <i className="fa fa-fw fa-filter text-primary" />
                </span>
                <input
                  id={`textFilterId_${popoverId}`}
                  type="text"
                  className="form-control"
                  style={{ background: 'none' }}
                  value={filterValue}
                  onChange={e => setFilterValue(e.currentTarget.value)}
                  autoComplete="off"
                  aria-autocomplete="none"
                  onKeyDown={e => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      applyTextFilter();
                    }
                  }}
                  onClick={e => {
                    e.stopPropagation();
                  }}
                />
              </div>
            ),
            toggleIcon: false
          },
          dropdownMenu: {
            className: 'p-2 r-5 b-secondary',
            options: [
              {
                className: 'p-2',
                notDropdownClass: true,
                onClick: () => {},
                children: (
                  <div className="filter-popup">
                    {popUpContent ? (
                      popUpContent
                    ) : (
                      <input
                        type="text"
                        className="form-control"
                        style={{ background: 'none' }}
                        value={filterValue}
                        onClick={e => e.stopPropagation()}
                        onChange={e => setFilterValue(e.target.value)}
                        autoComplete="nope"
                        onKeyDown={e => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            applyTextFilter();
                          }
                        }}
                      />
                    )}
                    <div className="pt-1 pb-1">
                      {showApplyButton && (
                        <CustomButton
                          outline
                          color="primary"
                          onClick={applyTextFilter}
                          disabled={!filterValue.trim()}
                        >
                          {buttonText ? buttonText : `Apply`}
                        </CustomButton>
                      )}
                      {popUpContent ? (
                        <CustomButton outline color="secondary" className="ml-2">
                          Close
                        </CustomButton>
                      ) : (
                        <CustomButton outline color="secondary" className="ml-2" onClick={clearTextFilter}>
                          Clear
                        </CustomButton>
                      )}
                    </div>
                  </div>
                )
              }
            ]
          }
        }}
      />
    </div>
  );
};
